import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const Privacy = () => {
  const { lang } = useLang();
  const { privacy_page } = locales;
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: { xs: "center", md: "flex-start" }, // Centre sur mobile
        paddingTop: { xs: "32px", md: "50px" }, // Moins de padding sur mobile
        textAlign: { xs: "center", md: "left" }, // Centre sur mobile
        maxWidth: { xs: "100%", md: "800px" }, // 100% sur mobile, 800px sur desktop
        width: "100%",
        px: { xs: 2, md: 0 }, // Padding horizontal sur mobile
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          marginBottom: "20px",
          fontSize: { xs: "2rem", md: "2.5rem" },
          wordBreak: "break-word",
        }}
      >
        {privacy_page.title[lang]}
      </Typography>

      <Typography
        variant="h5"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1.2rem", md: "1.5rem" },
          wordBreak: "break-word",
        }}
      >
        {privacy_page.last_updated[lang]}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1rem", md: "1.1rem" },
          wordBreak: "break-word",
        }}
      >
        {privacy_page.intro[lang]}
      </Typography>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.collection.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.collection.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.usage.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.usage.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.cookies.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.cookies.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.sharing.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.sharing.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.prospecting.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.prospecting.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.security.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.security.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.changes.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.changes.text[lang]}
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.contact.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {privacy_page.sections.contact.text[lang]}{" "}
          <Link href="mailto:contact@medicta.ch">contact@medicta.ch</Link>.
        </Typography>
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          textAlign: "center",
          fontSize: { xs: "0.95rem", md: "1rem" },
          mb: 2,
          wordBreak: "break-word",
        }}
      >
        {privacy_page.footer[lang]}
      </Typography>
    </Container>
  );
};

export default Privacy;
